const buildCurrentResidence = ({ isFinanciallyResponsible }) => {
  return {
    name: 'currentResidence',
    title: 'CURRENT RESIDENCE',
    container: 'collapse',
    GridProps: { xs: 12 },
    fields: [
      {
        variant: 'text',
        name: 'currentResidenceStreetAddress',
        label: 'Street Address',
        rules: {
          required: true,
        },
        GridProps: { xs: 12, sm: 4 },
      },
      {
        variant: 'text',
        name: 'currentResidenceCity',
        label: 'City',
        rules: {
          required: true,
        },
        GridProps: { xs: 12, sm: 3 },
      },
      {
        variant: 'singleSelect',
        name: 'currentResidenceState',
        label: 'State/Province',
        placeholder: 'Select',
        rules: {
          required: true,
        },
        GridProps: { xs: 12, sm: 3 },
      },
      {
        variant: 'text',
        name: 'currentResidenceZipCode',
        label: 'Zip Code/Postal Code',
        rules: {
          required: true,
        },
        GridProps: { xs: 12, sm: 2 },
      },
      ...(isFinanciallyResponsible
        ? [
            {
              variant: 'date',
              name: 'currentResidenceMoveInDate',
              label: 'Move-In Date',
              placeholder: 'MM/DD/YYYY',
              rules: {
                required: true,
                validate: (value) => {
                  if (value > new Date()) {
                    return 'Move-in date cannot be a future date';
                  }
                  return true;
                },
              },
              GridProps: { xs: 12, sm: 2 },
            },
            {
              variant: 'currency',
              name: 'currentResidenceMonthlyPayments',
              label: 'Current Monthly Payments',
              rules: {
                required: true,
                min: 0,
              },
              GridProps: { xs: 12, sm: 3 },
            },
            {
              variant: 'flexSpacer',
            },
            {
              name: 'currentOwnOrRentDetails',
              title: 'OWN OR RENT DETAILS',
              titleVariant: 'collapse',
              container: 'default',
              fields: [
                {
                  variant: 'radioGroup',
                  name: 'currentResidenceOwnOrRent',
                  label: 'Do you currently Own or Rent your property?',
                  options: [
                    { label: 'Own', value: 'own' },
                    { label: 'Rent', value: 'rent' },
                    { label: 'Do not currently Own/Rent', value: 'other' },
                  ],
                  rules: {
                    required: true,
                  },
                  sx: {
                    flexDirection: 'row',
                  },
                  GridProps: { xs: 12, marginTop: 2 },
                },
                {
                  variant: 'text',
                  name: 'currentResidenceLenderName',
                  label: 'Lender Name',
                  rules: {
                    required: true,
                  },
                  watchFields: ['currentResidenceOwnOrRent'],
                  hidden: ({ getValues }) =>
                    getValues('currentResidenceOwnOrRent') !== 'own',
                  GridProps: { xs: 12, sm: 6 },
                },
                {
                  variant: 'phone',
                  name: 'currentResidenceLenderPhone',
                  label: 'Phone Number',
                  placeholder: '(000) 000-0000',
                  rules: {
                    required: true,
                  },
                  watchFields: ['currentResidenceOwnOrRent'],
                  hidden: ({ getValues }) =>
                    getValues('currentResidenceOwnOrRent') !== 'own',
                  GridProps: { xs: 12, sm: 6 },
                },
                {
                  variant: 'text',
                  name: 'currentResidenceLandlordName',
                  label: 'Landlord/Condo/Apartment Name',
                  rules: {
                    required: true,
                  },
                  watchFields: ['currentResidenceOwnOrRent'],
                  hidden: ({ getValues }) =>
                    getValues('currentResidenceOwnOrRent') !== 'rent',
                  GridProps: { xs: 12, sm: 6 },
                },
                {
                  variant: 'phone',
                  name: 'currentResidenceLandlordPhone',
                  label: 'Phone Number',
                  placeholder: '(000) 000-0000',
                  rules: {
                    required: true,
                  },
                  watchFields: ['currentResidenceOwnOrRent'],
                  hidden: ({ getValues }) =>
                    getValues('currentResidenceOwnOrRent') !== 'rent',
                  GridProps: { xs: 12, sm: 6 },
                },
                {
                  variant: 'text',
                  name: 'currentResidenceReason',
                  label: 'Reason',
                  placeholder: 'Please explain...',
                  multiline: true,
                  rows: 3,
                  rules: {
                    required: true,
                  },
                  watchFields: ['currentResidenceOwnOrRent'],
                  hidden: ({ getValues }) =>
                    getValues('currentResidenceOwnOrRent') !== 'other',
                  GridProps: { xs: 12 },
                },
                {
                  variant: 'text',
                  name: 'currentResidenceReasonForMoving',
                  label: 'Reason for moving',
                  placeholder: 'Please explain...',
                  multiline: true,
                  rows: 3,
                  GridProps: { xs: 12 },
                },
              ],
            },
          ]
        : []),
    ],
  };
};

export default buildCurrentResidence;
